import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectCurrentSiteScopes } from 'app/selectors/ScopeSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import SearchActions from 'app/actions/SearchActions';
import { scopeShape } from 'app/shapes/search';
import SearchScopeField from './SearchScopeField';

const mapStateToProps = state => ({
  scopes: selectCurrentSiteScopes(state),
  currentSearchScope: state.getIn(['search', 'catalogSearch', 'scope']),
  excludeSearchScopeIds: selectCurrentLibrary(state).get('excludeSearchScopeIds', Immutable.List()),
  scopeFacetEnabled: selectCurrentLibrary(state).get('scopeFacetEnabled')
});

const mapDispatchToProps = dispatch => ({
  searchActions: bindActionCreators(SearchActions, dispatch)
});

const SearchScopeFieldContainer = ({ scopes, currentSearchScope, excludeSearchScopeIds, scopeFacetEnabled }) => {
  if (!scopeFacetEnabled || typeof scopes === 'undefined' || scopes.size <= 1) {
    return null;
  }

  const includedScopes = scopes.filter(scope => !excludeSearchScopeIds.includes(scope.get('scopeId')));

  return <SearchScopeField scopes={includedScopes} currentSearchScope={currentSearchScope} />;
};

SearchScopeFieldContainer.propTypes = {
  excludeSearchScopeIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  scopes: ImmutablePropTypes.listOf(scopeShape),
  scopeFacetEnabled: PropTypes.bool.isRequired,
  currentSearchScope: PropTypes.string
};

SearchScopeFieldContainer.displayName = 'SearchScopeFieldContainer';
export default connect(mapStateToProps, mapDispatchToProps)(SearchScopeFieldContainer);
